<div class="confirmation">
    <h2 class="confirmation-title" mat-dialog-title>{{configuration.title}}</h2>
    <mat-dialog-content class="confirmation-content">{{configuration.question}}</mat-dialog-content>
    <mat-dialog-actions class="confirmation-actions" *ngIf="configuration.title == 'Eliminar'">
        <button mat-raised-button [mat-dialog-close]="false">No</button>
        <button mat-raised-button class="new-buttom" [mat-dialog-close]="true">Si</button>
    </mat-dialog-actions>
    <mat-dialog-actions class="confirmation-actions" *ngIf="configuration.title !== 'Eliminar'">
        <button mat-raised-button class="new-buttom" [mat-dialog-close]="true">Cerrar</button>
    </mat-dialog-actions>
</div>